import axios from 'axios';
import * as types from '../mutation-types';
import endpoints from "../endpoints";

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    // properties to store slots data
    endpoint: endpoints.slot_report.endpoint, // "slot-report",
    uploadEndpoint: endpoints.slot_report.uploadEndpoint, // "reports-manager/counters-image-create",
  },
  // -----------------------------------------------------------------
  getters: {
    // getters and computed props on the slots data
    slots: state => state.slots,
    slotByID: state => id => {
      for (const slot of state.slots) {
        if (slot.id === id) return slot;
      }
      return undefined;
    },
  },
  // -----------------------------------------------------------------
  mutations: {
  },
  // -----------------------------------------------------------------
  actions: {
    fetch: (context, paginationData) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "s";

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: paginationData,
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            if (r.success) {
              if (r.data.rows == null) r.data.rows = [];
            }
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    create: (context, data) => {
      context.commit(`cache/${types.CACHE_INVALIDATE}`, 'shopReports', {
        root: true
      });

      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: data,
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    uploadURL: (context) => {
      context.commit(`cache/${types.CACHE_INVALIDATE}`, 'shopReports', {
        root: true
      });

      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.uploadEndpoint;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          method: 'GET'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
  }
};
